import { jsx as t } from "react/jsx-runtime";
import { ArrowSize as a, ArrowPosition as l } from "./CarouselArrows.types.js";
import "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import "@material-ui/core/Grid";
import n from "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemIcon";
import "@material-ui/core/ListItemText";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/createTheme";
import f from "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import "@material-ui/icons/Info";
import u from "@material-ui/icons/KeyboardArrowLeft";
import w from "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import "@material-ui/styles/ThemeProvider";
import { useCallback as c } from "react";
const d = f({
  arrow: {
    display: "flex",
    position: "absolute",
    zIndex: 1,
    background: "rgba(0, 0, 0, 0.7)",
    borderRadius: "50%",
    top: (o) => `calc((100% - ${o.size ?? a.medium}) / 2)`,
    fontSize: (o) => o.size ?? a.medium,
    margin: "0.5em"
  }
}), Ho = ({ onClick: o, size: i, position: m = l.INSIDE, style: p }) => {
  const e = d({ size: i }), s = c(
    (r) => {
      r.stopPropagation(), typeof o == "function" && o(r);
    },
    [o]
  );
  return /* @__PURE__ */ t(
    n,
    {
      "data-testid": "carousel-next-arrow",
      className: e.arrow,
      style: { right: m, ...p },
      onClick: s,
      size: "small",
      children: /* @__PURE__ */ t(
        w,
        {
          "data-testid": "carousel-next-arrow-icon",
          fontSize: "inherit",
          style: { color: "white" }
        }
      )
    }
  );
}, Jo = ({ onClick: o, size: i, position: m = l.INSIDE, style: p }) => {
  const e = d({ size: i }), s = c(
    (r) => {
      r.stopPropagation(), typeof o == "function" && o(r);
    },
    [o]
  );
  return /* @__PURE__ */ t(
    n,
    {
      "data-testid": "carousel-prev-arrow",
      className: e.arrow,
      style: { left: m, ...p },
      onClick: s,
      size: "small",
      children: /* @__PURE__ */ t(
        u,
        {
          "data-testid": "carousel-prev-arrow-icon",
          fontSize: "inherit",
          style: { color: "white" }
        }
      )
    }
  );
};
export {
  Ho as NextArrow,
  Jo as PrevArrow
};
//# sourceMappingURL=CarouselArrows.js.map
